var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.452 3.845h4.782l-.864 3.918h1.786l1.614-6.396c.499-.192 1.728-.518 2.65-.288l.092.022c1.082.27 1.459.363 1.29 1.82-.138 1.2-.979 5.071-1.382 6.858-.154.576-.277 1.855.46 2.362.923.634 1.038 5.128.52 7.03-.415 1.52-2.593 3.475-3.63 4.263l-.865 4.725H14.95l.922-3.457-1.67-.346-1.902 6.568c-1.287.154-3.907.173-4.091-.98-.186-1.152 1.074-6.164 1.727-8.527-.902-1.267-2.512-4.505-1.728-7.317.782-2.81 3.321-5.05 4.493-5.819l.75-4.435zm2.996 15.442a3.11 3.11 0 1 0 0-6.223 3.11 3.11 0 0 0 0 6.223z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRai);
export default __webpack_public_path__ + "static/media/RAI.0d7804e2ecc0c71c148f3eab916fd8e5.svg";
export { ForwardRef as ReactComponent };